export const scrollToOffer = () => {
  const offerSection = document.getElementById('oferta')
  if (offerSection) {
    offerSection.scrollIntoView({ behavior: 'smooth' })
  }
}
